module.exports = __webpack_public_path__ + "img/template2.7cd2f0b8.png";